import PropTypes from 'prop-types';
import { Box, Card, CircularProgress, Fab, Grid, Typography } from '@mui/material';
import React from 'react';
import { useStyles as useScrollbarStyle } from '../styles/hideScrollbarStyle';
import { GUEST } from '../../../../Constants/ProjectConstants';
import { convertHM } from '../../../../utils/timeCalculation';
import { useStyles } from '../styles/memberListCardStyles';

const MemberListCard = ({ memberList }) => {
  const scrollbarClasses = useScrollbarStyle();
  const classes = useStyles();
  const lastIndex = memberList?.length - 1 ?? 0;

  const listWrapperClasses = `${scrollbarClasses.hideScrollbar} ${classes.listWrapper}`;
  return (
    <Card>
      <Grid container width="100%">
        <div className={listWrapperClasses}>
          {memberList?.map((data, index) => (
            <MemberItem key={data.id} data={data} isLastIndex={lastIndex === index} />
          ))}
        </div>
      </Grid>
    </Card>
  );
};

function MemberItem({ data, isLastIndex }) {
  const classes = useStyles();
  if (data?.projectRoles?.roleName === GUEST) return null; // Skip this iteration

  const projectPercentage = data?.userHours === 0 ? 0 : ((data?.totalTime / 3600) * 100) / data?.userHours;

  // Variable for handling the percentage value above 100%
  const circularProgressBarValue = Math.min(projectPercentage, 100);

  // Variable for handling the color in progress bar
  let circularProgressBarColor;
  switch (true) {
    case projectPercentage < 71:
      circularProgressBarColor = '#229A16';
      break;
    case projectPercentage < 91:
      circularProgressBarColor = '#FFC107';
      break;
    default:
      circularProgressBarColor = '#FF4842';
      break;
  }

  return (
    <Box
      key={data?.id}
      className={classes.itemContainer}
      sx={{
        borderRight: isLastIndex ? 'none' : '1px dotted #ccc',
      }}
    >
      <Box className={classes.itemLeftSection}>
        <Fab aria-label="save" color="grey">
          {Math.round(projectPercentage)}%
        </Fab>

        <CircularProgress
          variant="determinate"
          size={68}
          value={circularProgressBarValue}
          sx={{
            color: circularProgressBarColor,
            position: 'absolute',
            top: -6,
            left: -6,
            zIndex: 1,
          }}
        />
      </Box>
      <Box className={classes.itemRightSection}>
        <Typography variant="h6" sx={{ whiteSpace: 'nowrap' }}>
          {data?.user?.userName}
        </Typography>
        <Typography variant="h7" sx={{ whiteSpace: 'nowrap' }}>
          {convertHM(Math.round(parseInt(data?.totalTime, 10)))} / {data?.userHours}h
        </Typography>
      </Box>
    </Box>
  );
}

MemberListCard.propTypes = {
  memberList: PropTypes.array,
};

MemberItem.propTypes = {
  data: PropTypes.object,
  isLastIndex: PropTypes.bool,
};
export default MemberListCard;
